import { render } from "./BudgetsAddView.vue?vue&type=template&id=2b959678"
import script from "./BudgetsAddView.vue?vue&type=script&lang=js"
export * from "./BudgetsAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__